import React from 'react'
import {
    SkeletonGridContainer,
    SkeletonContainer,
    ImagePlaceholder,
    BadgePlaceholderLeft,
    BadgePlaceholderRight,
    Content,
    TopRow,
    RatingPlaceholder,
    TitleLine,
    RatingIconLine,
    RatingTextLine,
    DescriptionLine,
} from './styles'

interface PropertyGridSkeletonProps {
    count?: number
}

const GridCardSkeleton: React.FC = () => (
    <SkeletonContainer>
        <ImagePlaceholder>
            <BadgePlaceholderLeft />
            <BadgePlaceholderRight />
        </ImagePlaceholder>

        <Content>
            <TopRow>
                <TitleLine />
                <RatingPlaceholder>
                    <RatingIconLine />
                    <RatingTextLine />
                </RatingPlaceholder>
            </TopRow>

            <DescriptionLine $width="85%" />
            <DescriptionLine $width="60%" $height="0.75rem" />
            <DescriptionLine $width="50%" $height="0.75rem" />
            <DescriptionLine $width="30%" $height="0.75rem" />
        </Content>
    </SkeletonContainer>
)

const PropertyGridSkeleton: React.FC<PropertyGridSkeletonProps> = ({ count = 4 }) => {
    return (
        <SkeletonGridContainer>
            {Array.from({ length: count }).map((_, i) => (
                <GridCardSkeleton key={i} />
            ))}
        </SkeletonGridContainer>
    )
}

export default PropertyGridSkeleton
